<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6JENkn/Images/cover.jpg?1685327487328" alt="This image is the cover for the book Quite A Spectacle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quite A Spectacle
      </h1>
      <p class="bookDescription body article font2">
        <p>Max moved away from his family to be with Michael, and his family never got over it. Now, for the first time in almost a decade, he’s going to return to London for the Christmas celebrations. He’s confident his family will welcome Michael with open, loving arms. At least that's what he tells himself.</p> <p>Michael doesn't have his head buried in the sand. He knows he has a lot to prove this Christmas, and he’s not sure if he’s up to the task. All these years and he’d never considered having to spend a holiday with Max’s family. Now that it’s happening he’s not scared to admit it—he’s terrified.</p><p><i>A story from the Dreamspinner Press 2014 Advent Calendar package "Celebrate!".</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meg Harding
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d7dc18a